import type * as React from 'react';

import { cn } from '../../lib/utils';

/**
 * GradientBackground — full-bleed vivid gradient approximating the onboarding
 * refresh's background (Figma `2776:8421`): red-orange at the top fading
 * vertically to yellow, pink washes in the top corners, and a soft light pool
 * along the bottom (the frame's soft-light ellipse) — as tunable CSS instead
 * of a binary asset (design D2).
 *
 * ponytail: CSS gradient, not the exported image. If a pixel-exact match is
 * ever demanded, swap the `style` for `backgroundImage: url(<exported.png>)`.
 */
export interface GradientBackgroundProps {
  className?: string;
}

const GRADIENT =
  'radial-gradient(55% 55% at 50% 108%, rgba(255,248,205,0.9) 0%, rgba(255,248,205,0) 65%), ' +
  'radial-gradient(32% 38% at -2% -8%, rgba(248,96,140,0.5) 0%, rgba(248,96,140,0) 70%), ' +
  'radial-gradient(32% 38% at 102% -8%, rgba(248,96,140,0.5) 0%, rgba(248,96,140,0) 70%), ' +
  'linear-gradient(180deg, #E8442D 0%, #F75F36 20%, #FF9838 46%, #FFC33F 70%, #FFDF55 100%)';

export const GradientBackground: React.FC<GradientBackgroundProps> = ({ className }) => {
  return (
    <div
      aria-hidden="true"
      className={cn('absolute inset-0 w-full h-full pointer-events-none', className)}
      style={{ backgroundImage: GRADIENT }}
    />
  );
};

GradientBackground.displayName = 'GradientBackground';
